// @flow

import { bitbucketDataCenter } from 'data/products/bitbucket';
import Category from 'model/Category';

export default new Category('code', bitbucketDataCenter);
